import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { Path, G } from 'react-native-svg';

const ThreeDots = ({ color = '#000', height = 24, width = 24 }) => {
    return (
        <View style={styles.container}>
            <Svg
                width={width}
                height={height}
                viewBox="0 0 65.093 65.093"
                fill={color}
            >
                <G>
                    <G>
                        <Path d="M32.652,2.276c-7.925,0-14.372,6.445-14.372,14.371c0,7.925,6.447,14.372,14.372,14.372 c7.925,0,14.372-6.447,14.372-14.372C47.025,8.724,40.576,2.276,32.652,2.276z M32.652,29.022 c-6.822,0-12.372-5.552-12.372-12.372c0-6.821,5.55-12.371,12.372-12.371c6.823,0,12.372,5.55,12.372,12.371 C45.025,23.47,39.477,29.022,32.652,29.022z" />
                        <Path d="M14.372,62.816c7.925,0,14.372-6.444,14.372-14.371c0-7.924-6.447-14.371-14.372-14.371 C6.447,34.074,0,40.521,0,48.445C0,56.37,6.446,62.816,14.372,62.816z M14.372,36.071c6.822,0,12.372,5.551,12.372,12.373 c0,6.818-5.55,12.371-12.372,12.371C7.55,60.815,2,55.263,2,48.444C2,41.622,7.549,36.071,14.372,36.071z" />
                        <Path d="M50.722,34.071c-7.926,0-14.372,6.447-14.372,14.373s6.446,14.371,14.372,14.371 c7.925,0,14.371-6.445,14.371-14.371C65.095,40.521,58.646,34.071,50.722,34.071z M50.722,60.816 c-6.821,0-12.372-5.55-12.372-12.371c0-6.819,5.551-12.371,12.372-12.371c6.82,0,12.371,5.552,12.371,12.371 C63.095,55.267,57.544,60.816,50.722,60.816z" />
                    </G>
                </G>
            </Svg>
        </View>
    );
};

export default ThreeDots;

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});
